import { useRelocateInventoryObject } from './api.ts'
import type { InventoryMapGeometry } from '@/widgets/InventoryMap'

export const useRelocateInventObject = () => {
  const { relocate: relocateObject } = useRelocateInventoryObject()

  const relocate = async (objectId: number, geometry: InventoryMapGeometry) => {
    await relocateObject({ object_id: objectId, geometry })
  }

  return {
    relocate,
  }
}
